<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Leave Report">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>
        <v-container fluid>
          <v-row dense>
            <v-col cols="4">
              <v-card>
                <v-card-title v-text="'Privileged/Casual Leave'"></v-card-title>
                <v-list-item>
                  <v-list-item-title>Annual Balance: </v-list-item-title>
                  <v-list-item-subtitle>{{annualBalanceCL}}</v-list-item-subtitle>

                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Current Balance: </v-list-item-title>
                  <v-list-item-subtitle>{{currentBalanceCL}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Utilized Leave: </v-list-item-title>
                  <v-list-item-subtitle>{{utilizedLeavesCL}}</v-list-item-subtitle>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card>
                <v-card-title v-text="'Sick Leave'"></v-card-title>
                <v-list-item>
                  <v-list-item-title>Annual Balance: </v-list-item-title>
                  <v-list-item-subtitle>{{annualBalanceSL}}</v-list-item-subtitle>

                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Current Balance: </v-list-item-title>
                  <v-list-item-subtitle>{{currentBalanceSL}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Utilized Leave: </v-list-item-title>
                  <v-list-item-subtitle>{{utilizedLeavesSL}}</v-list-item-subtitle>
                </v-list-item>
                <!-- <h3 class="ms-4">Annual Allotment: 0</h3> -->
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card>
                <v-card-title v-text="'Loss Of Pay (LOP)'"></v-card-title>
                <v-list-item>
                  <v-list-item-title>Already Taken: </v-list-item-title>
                  <v-list-item-subtitle>{{utilizedLeavesLOP}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Currently Applied: </v-list-item-title>
                  <v-list-item-subtitle>{{currentlyAppliedLOP}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>System Deducted: </v-list-item-title>
                  <v-list-item-subtitle>{{systemDeducted}}</v-list-item-subtitle>
                </v-list-item>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card>
                <v-card-title v-text="'View Leave Summary'"></v-card-title>
                <v-toolbar flat>
                  <!-- <v-col cols="12" sm="3">
                    <v-autocomplete class="mt-3" label="Year *" v-model="year"
                      v-on:change="getReport()" :items="yearOptions" key="id" item-value="id"
                      item-text="value">
                    </v-autocomplete>
                  </v-col> -->
                  <!-- <v-btn @click="getReport()" elevation="1" small>
                    View
                  </v-btn> -->
                  <v-btn @click="downloadCSVData()" class="ms-2" elevation="1" small>
                    Download
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table :headers="headers" :items="attendanceData" disable-pagination
                  hide-default-footer>

                  <template v-slot:item.actions="{ item }">
                    <v-btn v-if="!item.isPublish" color="success" class="px-2 ml-1 ma-1"
                      min-width="0"
                      v-on:click="()=>{$router.push({ name: 'editAudit', params: {id: item.id} })}"
                      small>
                      <v-icon small> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small
                      v-on:click="()=>{$router.push({ name: 'viewAudit', params: {id: item.id} })}">
                      <v-icon small> mdi-eye </v-icon>
                    </v-btn>
                    <!-- <v-btn color="success" v-else class="px-2 ml-1 ma-1" min-width="0" small>
              <v-icon small> mdi-reload </v-icon>
            </v-btn> -->
                  </template>

                  <template v-slot:no-data>
                    <v-card-subtitle class="d-flex justify-center">No Data Available
                    </v-card-subtitle>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import stores from '@/stores'
import Utils from '@/utils'
import _ from 'lodash'

export default {
  name: 'leaveReport',
  components: { VCardComponent, MaterialCard },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    this.yearOptionsHandler()
    await this.onFranchiseeChange()
  },
  data () {
    return {
      isLoading: false,
      attendanceData: [],
      attendanceData1: [
        {
          type: 'Casual Leave',
          month: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          encashed: 0
        },
        {
          type: 'Sick Leave',
          month: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          encashed: 0
        },
        {
          type: 'Loss of Pay',
          month: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          encashed: 0
        }
      ],
      headers: [
        { text: 'Type', value: 'type', sortable: true },
        { text: 'JAN', value: 'month.January', sortable: true },
        { text: 'FEB', value: 'month.Febuary', sortable: true },
        { text: 'MAR', value: 'month.March', sortable: true },
        { text: 'APR', value: 'month.April', sortable: true },
        { text: 'MAY', value: 'month.May', sortable: true },
        { text: 'JUN', value: 'month.June', sortable: true },
        { text: 'JUL', value: 'month.July', sortable: true },
        { text: 'AUG', value: 'month.August', sortable: true },
        { text: 'SEP', value: 'month.September', sortable: true },
        { text: 'OCT', value: 'month.October', sortable: true },
        { text: 'NOV', value: 'month.November', sortable: true },
        { text: 'DEC', value: 'month.December', sortable: true },
        { text: 'Total', value: 'encashed', align: 'center', sortable: false }
      ],
      yearOptions: [],
      franchiseeID: '',
      academicYearID: '',
      currentBalanceCL: '',
      currentBalanceSL: '',
      annualBalanceCL: '',
      annualBalanceSL: '',
      utilizedLeaves: '',
      utilizedLeavesCL: 0,
      utilizedLeavesSL: 0,
      utilizedLeavesLOP: 0,
      systemDeducted: 0,
      currentlyAppliedLOP: 0,
      year: new Date().getFullYear(),
      loader: false
    }
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true

        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }

        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (!this.franchiseeID) {
          Utils.helper.openDrawer(this)
        } else {
          Utils.helper.openDrawer(this, false)
        }
        if (this.franchiseeID && this.academicYearID) {
          await this.getLeaveDetail(this.franchiseeID)
        }
        this.inProgress = false
      }
    },
    getReport () {
      // this.attendanceData = []
      this.getLeaveDetail()
    },
    yearOptionsHandler () {
      let max = new Date().getFullYear()
      let min = max - 30

      for (var i = min; i <= max; i++) {
        this.yearOptions.push({
          id: i,
          value: i
        })
      }
      this.yearOptions = _.orderBy(this.yearOptions, ['id'], ['desc'])
    },
    getLeaveDetail: async function (franchiseeID) {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/attendanceModule/leavereport?academicYearID=${this.academicYear.id}&franchiseeID=${this.franchisee.id}`)
        this.data = response.data
        this.systemDeducted = this.data.systemDeducted
        let casualLeaveCB = this.data.currentBalance.filter((item) => {
          return item.name === 'Casual Leave'
        })
        let sickLeaveCB = this.data.currentBalance.filter((item) => {
          return item.name === 'Sick Leave'
        })
        let casualLeaveAB = this.data.annualBalance.filter((item) => {
          return item.name === 'Casual Leave'
        })
        let sickLeaveAB = this.data.annualBalance.filter((item) => {
          return item.name === 'Sick Leave'
        })

        this.currentBalanceCL = casualLeaveCB.reduce((acc, val) => {
          return acc + val.count
        }, 0)
        this.currentBalanceSL = sickLeaveCB.reduce((acc, val) => {
          return acc + val.count
        }, 0)
        this.annualBalanceCL = casualLeaveAB.reduce((acc, val) => {
          return acc + val.count
        }, 0)
        this.annualBalanceSL = sickLeaveAB.reduce((acc, val) => {
          return acc + val.count
        }, 0)

        this.currentlyAppliedLOP = this.data.currentAppliedLossOfPay || 0
        this.utilizedLeavesSL = this.data.utilizedLeaves
          .filter((item) => {
            return item.name === 'Sick Leave'
          })
          .reduce((acc, val) => {
            return acc + val.count
          }, 0)
        this.utilizedLeavesCL = this.data.utilizedLeaves
          .filter((item) => {
            return item.name === 'Casual Leave'
          })
          .reduce((acc, val) => {
            return acc + val.count
          }, 0)
        this.utilizedLeavesLOP = this.data.utilizedLeaves
          .filter((item) => {
            return item.name === 'Loss of Pay'
          })
          .reduce((acc, val) => {
            return acc + val.count
          }, 0)

        if (this.data.annualLeaveReport) {
          this.attendanceData = []
          this.data.annualLeaveReport.forEach((item) => {
            let obj = {}
            obj.type = item.attendanceleavetype
            delete item.attendanceleavetype
            obj.month = item
            let keys = Object.keys(item)
            let encashed = 0
            keys.forEach((month) => {
              if (month !== 'attendanceleavetype') {
                encashed += item[month]
              }
            })
            obj.encashed = encashed
            this.attendanceData.push(obj)
          })
          let obj = {}
          let temp = {}
          let months = ['January', 'Febuary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
          months.forEach((month) => {
            temp[month] = 0
            obj.encashed = 0
            this.attendanceData.forEach((current) => {
              temp[month] += current.month[month]
              obj.encashed += current.encashed
            })
          })
          obj.type = 'Total'
          obj.month = temp
          this.attendanceData.push(obj)
        }
        this.isLoading = false
        // } else {
        //   if (!franchiseeID) {
        //     this.$buefy.toast.open({
        //       message: 'Please select a franchisee from the sidebar.',
        //       type: 'is-danger',
        //       duration: 2000
        //     })
        //   } else {
        //     this.$dialog.error({
        //       title: 'Error',
        //       text: 'Please select an academic year from the sidebar.'
        //     })
        //   }
        // }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching leave details : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    downloadCSVData: async function () {
      let csv = 'Leave Type,JAN,FEB,MAR,APR,MAY,JUN,JUL,AUG,SEP,OCT,NOV,DEC,Total\n'
      let months = ['January', 'Febuary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      this.attendanceData.forEach((row) => {
        csv += row.type + ','
        months.forEach((mon) => {
          csv += row.month[mon] + ','
        })
        csv += row.encashed
        csv += '\n'
      })
      const anchor = document.createElement('a')
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
      anchor.target = '_blank'
      let user = stores.user.me
      anchor.download = `${user.firstName}_${user.lastName}_Leaves_${this.year}.csv`
      anchor.click()
    }
  }
}
</script>

<style scoped>
.v-sheet.v-card {
  padding-bottom: 10px;
}
</style>
